import CodeBlock from '../components/CodeBlock';
import PlanBadge from '../components/PlanBadge';
import { deviceOptions } from '../data/parameters';

export default function DeviceEmulation() {
  return (
    <section id="device" className="mb-16">
      <div className="flex items-center gap-3 mb-4">
        <h3 className="text-2xl font-bold text-gray-900">POST /screenshot/device</h3>
        <PlanBadge plan="starter" />
      </div>
      <p className="text-gray-700 mb-6">
        Emulate specific devices to see how websites render on different screens.
        Available on Starter, Growth, and Pro plans.
      </p>

      <h4 className="text-lg font-semibold text-gray-900 mb-3">Available Devices</h4>
      <ul className="list-disc list-inside text-gray-700 mb-6 space-y-1">
        {deviceOptions.map((device, index) => (
          <li key={index}>{device}</li>
        ))}
      </ul>

      <h4 className="text-lg font-semibold text-gray-900 mb-3">Example</h4>
      <CodeBlock section="device" />
    </section>
  );
}